// extracted by mini-css-extract-plugin
export var wordContainer = "_qi-0";